export default {
  overruleResult: 'Prepísať výsledok',
  overruleReason: 'Dôvod prepísania',
  overruleResultLabel: 'Prepísať výsledok',
  valueSensorMeaningsPlaceholder: 'Vybrať hlavný signál',
  durationMeaningsPlaceholder: 'Vybrať signál trvania',
};
